import React, { ReactElement } from 'react'

export const Layout3x1: React.FC = (): ReactElement => (
    <div className='layout-3x1'>
        <svg x='0px' y='0px' viewBox='0 0 30 30'>
            <rect x='2' y='2' className='dashboard-background-1 dashboard-layout-entry-square' width='8' height='26' />
            <text
                transform='matrix(0.9375 0 0 1 4.4736 17.6875)'
                className='dashboard-foreground-1 dashboard-layout-entry-text'
            >
                1
            </text>
            <rect
                x='11.5'
                y='2'
                className='dashboard-background-2 dashboard-layout-entry-square'
                width='7.8'
                height='26'
            />
            <text
                transform='matrix(0.9375 0 0 1 13.6135 17.6875)'
                className='dashboard-foreground-2 dashboard-layout-entry-text'
            >
                2
            </text>
            <rect
                x='21'
                y='2'
                className='dashboard-background-3 dashboard-layout-entry-square'
                width='7.3'
                height='26'
            />
            <text
                transform='matrix(0.9375 0 0 1 22.8135 17.6875)'
                className='dashboard-foreground-3 dashboard-layout-entry-text'
            >
                3
            </text>
            <path className='dashboard-layout-outer-border' d='M28,2v26H2V2H28 M30,0H0v30h30V0L30,0z' />
            <line className='central-border-line' x1='10.5' y1='1' x2='10.5' y2='30' />
            <line className='central-border-line' x1='20.2' y1='1' x2='20.2' y2='30' />
        </svg>
    </div>
)
